<template>
  <div>
    <Board class="mb-6">
      <template #header class="mb-6">
        <div class="w_header">
          <BaseTitle v-text="$t('workflow.cosmoform.template_management')" />
        </div>
      </template>
      <template #main>
        <BaseDivider class="my-5" :grey="true" />
        <div>
          <div class="d-flex">
            <BaseButton
              class="ml-auto"
              icon="$mdiPlus"
              @click="$emit('createFormTemplate')"
            >
              {{ $t("workflow.cosmoform.create") }}
            </BaseButton>
          </div>
        </div>
        <div class="effect_list">
          <BaseDataTable
            :items="formTemplates"
            :loading="loading"
            :loading-text="$t('utils.loadingData')"
            hide-default-footer
          >
            <template #header>
              <thead>
                <tr>
                  <th>{{ $t("utils.title") }}</th>
                  <th>{{ $t("utils.isSequential") }}</th>
                  <th class="text-end">{{ $t("utils.dateCreated") }}</th>
                  <th class="text-end">
                    {{ $t("utils.actions") }}
                  </th>
                </tr>
              </thead>
            </template>
            <template #item="{ item }">
              <tr class="tab_row">
                <td>
                  <div class="row_item">
                    <div class="item_label" v-text="item.title" />
                  </div>
                </td>
                <td>
                  <div class="row_item">
                    <div
                      class="item_label"
                      v-text="
                        item.isSequential
                          ? $tc('utils.active', 1)
                          : $tc('utils.active', 2)
                      "
                    />
                  </div>
                </td>
                <td>
                  <div class="row_item text-end">
                    <div
                      class="item_label"
                      v-text="$d(new Date(item.dateCreated), 'veryshort')"
                    />
                  </div>
                </td>
                <td>
                  <div class="d-flex">
                    <BaseButtonIcon
                      class="ml-auto"
                      small
                      icon="$mdiEdit"
                      color="primary"
                      @click.stop="editFormTemplate(item)"
                    />
                    <BaseButtonIcon
                      class="ml-2"
                      small
                      icon="$mdiTrashCanOutline"
                      color="secondary"
                      @click.stop="deleteForm(item)"
                    />
                  </div>
                </td>
              </tr>
            </template>
          </BaseDataTable>
        </div>
      </template>
    </Board>
    <BaseModal
      v-if="isOpen"
      :value="isOpen"
      :modal-title="$t('cosmoform.confirmationDelete')"
      persistent
      @close="isOpen = false"
    >
      <template #modal>
        <div class="text-center">
          <BaseParagraph
            v-text="$t('cosmoform.confirmText', { count: usageCount })"
          />
        </div>
      </template>
      <template #actions>
        <BaseButton
          text
          class="mx-2 ml-auto"
          type="secondary"
          color="#707080"
          @click="isOpen = false"
        >
          {{ $t("utils.cancel") }}
        </BaseButton>
        <BaseButton
          color="secondary"
          type="primary"
          :loading="isSubmitting"
          @click="deleteFormTemplate"
        >
          {{ $t("utils.delete") }}
        </BaseButton>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import Board from "@/core/Components/Board.vue";
import {
  deleteOrganizationWorkflowCosmoformTemplate,
  getOrganizationWorkflowCosmoformTemplateUsage,
} from "../Services/workflow.service";

export default {
  name: "CosmoformTemplate",
  components: {
    Board,
  },
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
    formTemplates: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      isOpen: false,
      usageCount: 0,
      templateId: null,
      isSubmitting: false,
    };
  },
  methods: {
    editFormTemplate(item) {
      this.$emit("editFormTemplate", item);
    },
    async deleteForm(item) {
      this.templateId = item.id;
      try {
        const response = (
          await getOrganizationWorkflowCosmoformTemplateUsage({
            organizationId: this.organizationId,
            workflowId: this.$route.params.workflowId,
            templateId: this.templateId,
          })
        ).data;
        this.usageCount = response.effects;
        if (this.usageCount > 0) {
          return (this.isOpen = true);
        }
        await this.deleteFormTemplate();
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
    },
    async deleteFormTemplate() {
      this.isSubmitting = true;
      try {
        await deleteOrganizationWorkflowCosmoformTemplate({
          organizationId: this.organizationId,
          workflowId: this.$route.params.workflowId,
          templateId: this.templateId,
        });
        this.$emit("form-deleted", {
          formId: this.templateId,
          needRefreshEffect: this.usageCount > 0,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("cosmoform.deletedSuccess"),
          type: "SUCCESS",
        });
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isOpen = false;
      this.isSubmitting = false;
    },
    truncateDescription(description) {
      return description.length > 200
        ? description.substring(0, 175) + "..."
        : description;
    },
  },
};
</script>

<style lang="scss" scoped>
.question_list {
  display: flex;
  flex-wrap: wrap;

  .question_item {
    border: 1px solid #2536cc;
    margin: 8px;
    height: 33px;
    padding: 6px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    .name {
      margin: 0 5px;
      font-size: 16px;
      line-height: 18px;
      color: #2536cc;
      max-height: 36px;
      text-align: center;
      overflow: hidden;
    }
  }
}
.label-trunk {
  font-size: 14px !important;
}
</style>
